import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  AccordionPanelStyled,
  AccordionStyled,
  TextStyled,
} from '@nike/nike-design-system-components';
import Link from '../Link';
import {
  StyledAccordionContainer,
  accordionPanelWrapper,
  footerLink,
  accordionDetails,
} from './styles';
import { AnalyticsContext } from '../../context/analyticsContext';

/**
 * Renders the mobile footer menu, specifically the accordion menu and the language tunnel
 * @param {object} props
 * @param {{children: Array, header: { label: string }}[]} [props.columns]
 * @returns {React.ReactElement}
 */
const MobileFooterMenu = props => {
  const { columns } = props;
  const { analyticsClient } = useContext(AnalyticsContext);
  if (!columns) return null;

  return (
    <StyledAccordionContainer className="mobile-footer-accordion" data-testid="mobile-footer-menu">
      <AccordionStyled animatable={true} id="footer-accordion" open={[0]} singlePanelOpenAtATime>
        {columns.map(({ children, header }, index) => (
          <AccordionPanelStyled
            classes={{ summary: accordionPanelWrapper, details: accordionDetails }}
            detailsTitle={<TextStyled appearance="body2Strong">{header.label}</TextStyled>}
            id={`accordion-panel-${index}`}
            key={index}
          >
            <>
              {children.map((link, linkIndex) => {
                const destination = link.url;
                if (!destination) return null;
                const linkKey = `FooterColumnItem-${index}-${linkIndex}`;
                return (
                  <Link
                    className={footerLink}
                    href={destination}
                    key={linkKey}
                    onClick={() => {
                      analyticsClient?.clickNavFooter({
                        path: link.path.join(':'),
                        hashKey: link.hashKey,
                      });
                    }}
                    path={link.path}
                    target={link.target}
                  >
                    <TextStyled appearance="body2Strong" color="secondary">
                      {link?.label}
                    </TextStyled>
                  </Link>
                );
              })}
            </>
          </AccordionPanelStyled>
        ))}
      </AccordionStyled>
    </StyledAccordionContainer>
  );
};

MobileFooterMenu.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.arrayOf(PropTypes.object),
    }),
  ),
};

export default MobileFooterMenu;
